import React from 'react'
import { CircularProgress } from '@mui/material'

function Loading () {
  return (<div style={
        {
          display: 'flex',
          position: 'fixed',
          top: 0,
          height: '100vh',
          width: '100%',
          justifyContent: 'center',
          alignItems: 'center',
          background: '#FFFFFF'
        }
    }>
        <CircularProgress/>
    </div>)
}

export default Loading
